/*---------------------------------------------------------------------------------------------
* Copyright (c) Bentley Systems, Incorporated. All rights reserved.
* See LICENSE.md in the project root for license terms and full copyright notice.
*--------------------------------------------------------------------------------------------*/

import { useSandboxAutomation } from "hooks/useSandboxAutomation";
import { useEffect } from "react";
import { RouterProvider } from "react-router-dom";
import { router } from "router";
import { AuthManager } from "services/auth-service/auth";
import { reactPlugin } from "services/telemetry-service/telemetry";
import { useAppSelector } from "store/hooks";
import { ThemeProvider } from "@itwin/itwinui-react";
import { AppInsightsContext } from "@microsoft/applicationinsights-react-js";
import { Provider } from "react-redux";
import { store } from "store/reduxStore";
import "./App.css";

const App = () => {
  const theme = useAppSelector((state) => state.settings.theme);

  useSandboxAutomation();

  useEffect(() => {
    void AuthManager.silentsignIn();
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <AppInsightsContext.Provider value={reactPlugin}>
        <RouterProvider router={router} />
      </AppInsightsContext.Provider>
    </ThemeProvider>
  );
};

export const SandboxApp = () => {
  return (
    <Provider store={store}>
      <App />
    </Provider>
  )
}

export default SandboxApp;
